import {Component, OnInit} from '@angular/core';
import {ListItemsComponent} from '@abstract/list-items/list-items.component';
import {WorkingObjectPagesService} from '../services/working-object-pages.service';
import {WorkingObjectsApiService} from '@api/working-objects.api.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {AuthService} from '@services/auth.service';
import {EventsService} from '@services/events.service';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';

@Component({
    selector: 'app-objects-list',
    templateUrl: 'objects-list.component.html'
})

export class ObjectsListComponent extends ListItemsComponent<WorkingObjectPagesService> implements OnInit {
    constructor(
        listService: WorkingObjectPagesService,
        private api: WorkingObjectsApiService,
        private authService: AuthService,
        private events: EventsService,
    ) {
        super(listService);
    }

    public canRemove = false;

    ngOnInit(): void {
        super.ngOnInit();
        this.canRemove = this.authService.hasPermissions([UserNamespace.Permission.workingObjectDelete]);
    }

    onRemoveClick() {
        if (!this.canRemove) {
            return;
        }

        this.events.showConfirm({
            title: 'Вы уверены, что хотите удалить выбранные объекты?',
            confirmButtonTitle: 'Удалить',
        }).subscribe(() => {
            this.api.deleteMultiple({
                queryParams: {
                    id: this.selectedValues$.getValue()
                }
            }).toPromise().then(() => {
                this.events.showNoty({
                    type: 'success',
                    content: NotyMessagesEnum.workingObjectListRemovedMessage
                });
                this.clearAllValues();
                this.service.updateItems();
            }, error => {
                this.events.showNoty({
                    type: 'error',
                    content: NotyMessagesEnum.workingObjectListRemovedFailMessage
                });
            });
        }, () => {});
    }
}
